// Contact Popup Open Script

// Default
function openContactPopup(){
  $('.contactPopupWrapper').addClass('active')
  $('.contactPopupWrapper .popupMainTwo').hide()
  $('.contactPopupWrapper .popupMain').show()
  $('body').css('overflow','hidden')
}

$(document).on('click', '.selectBtn', openContactPopup)

// Contact Choice
$('button.contact-choice').on('click', function(){
  $('.contactPopupWrapper .popupHeader span').text(window.location.pathname.includes('/ar') ? 'الموضوع' : 'Subject')
  $('.contactPopupWrapper ul').hide();
  $('.contactPopupWrapper ul.requestOptions').show();
});

$('.contactPopupWrapper ul.requestOptions li').on('click', function(){
  var txt = $(this).text();
  let container = $('section.clContact .formBox form .subjectBoxContent')
  $('.contact-choice span.value').text(txt);
  $('.contact-choice').addClass('selected');
  $('#contact-choice').val(txt);
  $('.subject-choice').removeClass('selected');
  $('.subject-choice span.value').text('');
  $('.contactPopupWrapper').removeClass('active');
  $('.selectBtn.sous-catégorie').closest('.padding').remove();
  container.find('.heel-height, .color, .size, .style').remove()
});

// Subject Choice
$('button.subject-choice').on('click', function(){
  $('.contactPopupWrapper .popupHeader span').text(window.location.pathname.includes('/ar') ? 'الموضوع' : 'Subject')
  $('.contactPopupWrapper ul').hide();
  if ($('#contact-choice').val() === 'Products and services') {
    $('.contactPopupWrapper ul.subjectOptions2').show();
  } else {
    $('.contactPopupWrapper ul.subjectOptions').show();
  }
});

// Contact Popup li selector

// Default
$('.contactPopupWrapper ul.requestOptions li').on('click', function(){
  var txt = $(this).text();
  $('.contact-choice span.value').text(txt);
  $('.contact-choice').addClass('selected');
  $('section.clContact .formBox form .subjectBox').addClass('active');
  $('#contact-choice').val(txt);
  $('.contactPopupWrapper').removeClass('active');
});

// Subject Choice
$('.contactPopupWrapper ul.subjectOptions li, .contactPopupWrapper ul.subjectOptions2 li').on('click', function(){
  var txt = $(this).text();
  let container = $('section.clContact .formBox form .subjectBoxContent')
  $('.subject-choice span.value').text(txt);
  $('.subject-choice').addClass('selected');
  $('section.clContact .formBox form .subjectBox').addClass('active');
  $('#subject-choice').val(txt);
  $('.contactPopupWrapper').removeClass('active');
  $('.selectBtn.sous-catégorie').closest('.padding').remove();
  container.find('.heel-height, .color, .size, .style').remove()
});

// Sous catégorie

function openSousCategoriePopup() {
  $('.contactPopupWrapper .popupHeader span').text('Sous catégorie')
  $('.contactPopupWrapper ul').hide()
  $('.contactPopupWrapper ul.sous-catégorie').show()
}
function handleSousCategorieChoice() {
  let txt = $(this).text().trim()
  let container = $('section.clContact .formBox form .subjectBoxContent')

  container.find('.heel-height, .color, .size, .style').remove()

  if (txt === 'Women Shoes') {
    container.children('div').eq(1).after(`
      <div class="padding heel-height min-55">
        <input type="text" name="contact[Heel Height]" id="heel-height" autocomplete="off" placeholder="Heel Height">
      </div>
      <div class="padding color min-55">
        <input type="text" name="contact[Color]" id="color" autocomplete="off" placeholder="Color">
      </div>
      <div class="padding size min-55">
        <input type="text" name="contact[Size]" id="size" autocomplete="off" placeholder="Size">
      </div>
      <div class="padding style min-55">
        <input type="text" name="contact[Style]" id="style" autocomplete="off" placeholder="Style">
      </div>
    `)

  } else if (txt === 'Bags') {
    container.children('div').eq(1).after(`
      <div class="padding color min-55">
        <input type="text" name="contact[Color]" id="color" autocomplete="off" placeholder="Color">
      </div>
      <div class="padding style min-55">
        <input type="text" name="contact[Style]" id="style" autocomplete="off" placeholder="Style">
      </div>
    `)

  } else if (txt === 'Men shoes') {
    container.children('div').eq(1).after(`
      <div class="padding color min-55">
        <input type="text" name="contact[Color]" id="color" autocomplete="off" placeholder="Color">
      </div>
      <div class="padding size min-55">
        <input type="text" name="contact[Size]" id="size" autocomplete="off" placeholder="Size">
      </div>
      <div class="padding style min-55 fullWidth">
        <input type="text" name="contact[Style]" id="style" autocomplete="off" placeholder="Style">
      </div>
    `)

  } else if (txt === 'Small Leather Goods') {
    if ($('#contact-choice').val() != 'Products and services') {
      container.children('div').eq(1).after(`
        <div class="padding color min-55">
          <input type="text" name="contact[Color]" id="color" autocomplete="off" placeholder="Color">
        </div>
        <div class="padding style min-55">
          <input type="text" name="contact[Style]" id="style" autocomplete="off" placeholder="Style">
        </div>
      `)
    }
  }

  $('.sous-catégorie span.value').text(txt)
  $('.sous-catégorie').addClass('selected')
  $('section.clContact .formBox form .subjectBox').addClass('active')
  $('#sous-catégorie').val(txt)
  $('.contactPopupWrapper').removeClass('active')
}

$('.contactPopupWrapper ul.subjectOptions li, .contactPopupWrapper ul.subjectOptions2 li').on('click', function(){
  var txt=$(this).text().trim();
  if(txt=='Product inquiry'){
    $('.subject-choice span.value').text(txt);
    $('.subject-choice').addClass('selected');
    $('section.clContact .formBox form .subjectBox').addClass('active');
    $('#subject-choice').val(txt);
    $('.contactPopupWrapper').removeClass('active');
    $('section.clContact .formBox form .subjectBoxContent > div:first').after('<div class="padding"><button type="button" class="selectBtn sous-catégorie"><input type="hidden" name="contact[Sous catégorie]" id="sous-catégorie" value="Product inquiry"><span class="label">Sous catégorie *</span><span class="value"></span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><g fill="#000"><path d="M12.5 16.55L5 9.05 6.05 8 12.5 14.45 18.95 8 20 9.05z"></path></g></g></svg></button></div>');
    $(document).on('click', '.selectBtn', openContactPopup)
    $(document).on('click', 'button.sous-catégorie', openSousCategoriePopup)
    $(document).on('click', '.contactPopupWrapper ul.sous-catégorie li', handleSousCategorieChoice)
  }
});
// Contact Popup Off Script 

$('.contactPopupWrapper').on('click', function(e){
  if (!$(e.target).closest('.popupContent').length) $(this).removeClass('active');
  $('body').css('overflow','')
});
$('.closePopup').on('click', function(){
  $('.contactPopupWrapper').removeClass('active');
  $('body').css('overflow','')
});

// Input Active

$('.clContact .formBox .inputBox input').on('focus input blur', function () {
  let box = $(this).closest('.inputBox')
  $(this).val() || this === document.activeElement ? box.addClass('active') : box.removeClass('active')
})

// Button Color Change
$(function(){
  const f=$('section.clContact .formBox form'),
        i=f.find('#message,#last-name,#first-name,#phone,#email'), 
        b=f.find('.submit input[type=submit]');
  const check=()=>{const ok=i.filter((_,e)=>e.value.trim()).length===5&&$('.subject-choice.selected').length;b.css({background:ok?'#ce0a2c':'',pointerEvents:ok?'auto':'none'});};
  check();i.on('input',check);$(document).on('click','.subject-choice',check);
});

// Popup Open script
document.addEventListener('DOMContentLoaded', () => {
  if(window.location.pathname.includes('/ar')) {
    document.querySelectorAll('p').forEach(p => {
      if(p.innerHTML.includes('اعرف المزيد عن إدارة بياناتك وحقوقك.')) {
        p.innerHTML = p.innerHTML.replace(
          'اعرف المزيد عن إدارة بياناتك وحقوقك.', 
          '<a href="#openSide" title="#openSide">اعرف المزيد عن إدارة بياناتك وحقوقك.</a>'
        )
      }
    })

    document.querySelectorAll('a[href="#openSide"]').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault()
        document.querySelector('.contactPopupWrapper').classList.add('active')
        document.querySelector('.contactPopupWrapper .popupHeader span').innerText = 'Your data and your rights'
        document.querySelector('.contactPopupWrapper .popupMainTwo').style.display = 'block'
        document.querySelector('.contactPopupWrapper .popupMain').style.display = 'none'
      })
    })
  }
})

document.querySelectorAll('a[href="#openSide"]').forEach(link => {
  link.addEventListener('click', e => {
    e.preventDefault()
    document.querySelector('.contactPopupWrapper').classList.add('active')
    document.querySelector('.contactPopupWrapper .popupHeader span').innerText = 'Your data and your rights'
    document.querySelector('.contactPopupWrapper .popupMainTwo').style.display = 'block'
    document.querySelector('.contactPopupWrapper .popupMain').style.display = 'none'
  })
})

